import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Link from "next/link";
import { Tab, Nav, Row, Col } from "react-bootstrap";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { withServerStore } from "../../store";
import {
  getAddressInfo,
  getBrandList,
  getCategoryList,
  getCmsList,
  getDynamicPageList,
  getLocations,
  getMetaData,
  getSitemap,
  toggleLoader,
} from "store/actions";
import {
  get_cookie,
  makeCityStateSlugUsingLocation,
  metaTags,
  strToLowerCase,
} from "utils";
import MetaTags from "components/meta-tags";
import { ContentLoader } from "components/loader";

const SiteMap = ({
  locations,
  brandList,
  categoryList,
  addressInfo,
  dynamicPageList,
  currentLocationId,
  isShowAddressInfo,
  selectedLocationName,
  cmsList,
}) => {
  const dispatch = useDispatch();
  const [navIndex, setNavIndex] = useState(0);
  const sitemap = useSelector((state) => state?.sitemap?.sitemapDetails);
  const loaders = useSelector((state) => state?.ui?.loaders);
  const [isReload, setIsReload] = useState(false);

  const sitemapblogs = sitemap.blogs;
  const sitemapCms = sitemap.cms;

  useEffect(() => {
    dispatch(toggleLoader("page_loader", true));
    dispatch(getSitemap()).then((res) => {
      if (get_cookie("cityStateSlug")) {
        res?.locations?.forEach((row, index) => {
          const slug = makeCityStateSlugUsingLocation(row);
          if (get_cookie("cityStateSlug") == slug) {
            setNavIndex(index);
            setTimeout(() => {
              setIsReload(true);
              dispatch(toggleLoader("page_loader", false));
            });
          }
        });
      }
    });
  }, []);

  return (
    <>
      {loaders && loaders.page_loader && <ContentLoader />}
      <MetaTags metaData={metaTags} />
      <Header
        locations={locations}
        brandList={brandList}
        categoryList={categoryList}
        currentLocationId={currentLocationId}
        headerDark={false}
        headerWhite={true}
      />

      {isReload && (
        <>
          <section className="sitemap-page">
            <div className="sitemap-page-inner">
              <div className="custom-container">
                <div className="sitemap-block">
                  <h2 className="sitemap-title">Site Map</h2>

                  <div className="sitemap-tabs">
                    <Tab.Container defaultActiveKey={navIndex}>
                      <Nav variant="tabs">
                        {/* Repeate below element dynamically */}
                        {sitemap?.locations?.map((sitemap1, index) => {
                          return (
                            <Nav.Item key={index}>
                              <Nav.Link eventKey={index}>
                                {sitemap1.city_name}
                              </Nav.Link>
                            </Nav.Item>
                          );
                        })}
                      </Nav>
                      <Tab.Content>
                        {/* Repeate below element dynamically */}
                        {sitemap?.locations?.map((sitemap1, index) => (
                          <Tab.Pane eventKey={index} key={index}>
                            <Row>
                              {/* Dynamically Repeat below Element */}
                              <Col md={4} sm={6}>
                                <div className="sitemap-listing-block">
                                  <h3 className="sitema-listing-title">
                                    brands
                                  </h3>
                                  <ul className="sitemap-listing">
                                    {/* Dynamically Repeat below Element */}
                                    {sitemap1.brands.map((brand, index) => (
                                      <li
                                        className="sitemap-listing-item"
                                        key={index}
                                      >
                                        <Link
                                          href={
                                            "/" +
                                            strToLowerCase(
                                              sitemap1.state_short_name
                                            ) +
                                            "/" +
                                            strToLowerCase(sitemap1.city_slug) +
                                            "/" +
                                            strToLowerCase(brand.slug)
                                          }
                                        >
                                          <a className="sitemap-listing-link">
                                            {brand.title}
                                          </a>
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </Col>

                              <Col md={4} sm={6}>
                                <div className="sitemap-listing-block">
                                  <h3 className="sitema-listing-title">
                                    Categories
                                  </h3>

                                  <ul className="sitemap-listing">
                                    {sitemap1.categories.map(
                                      (categorie, index) => (
                                        <li
                                          className="sitemap-listing-item"
                                          key={index}
                                        >
                                          <Link
                                            href={
                                              "/" +
                                              strToLowerCase(
                                                sitemap1.state_short_name
                                              ) +
                                              "/" +
                                              strToLowerCase(
                                                sitemap1.city_slug
                                              ) +
                                              "/" +
                                              strToLowerCase(categorie.slug)
                                            }
                                          >
                                            <a className="sitemap-listing-link">
                                              {categorie.title}
                                            </a>
                                          </Link>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              </Col>

                              {sitemap1.brands
                                .sort((a, b) => a.title.localeCompare(b.title))
                                .map((brand, index) => (
                                  <Col md={4} sm={6} key={index}>
                                    <div className="sitemap-listing-block">
                                      <h3 className="sitema-listing-title">
                                        {brand.title}
                                      </h3>

                                      <ul className="sitemap-listing">
                                        {brand.vehicles?.map(
                                          (vehicle, index) => (
                                            <li
                                              className="sitemap-listing-item"
                                              key={index}
                                            >
                                              <Link
                                                href={
                                                  "/" +
                                                  strToLowerCase(
                                                    sitemap1.state_short_name
                                                  ) +
                                                  "/" +
                                                  strToLowerCase(
                                                    sitemap1.city_slug
                                                  ) +
                                                  "/" +
                                                  strToLowerCase(brand.slug) +
                                                  "/" +
                                                  strToLowerCase(
                                                    vehicle.category_detail
                                                      ?.slug
                                                  ) +
                                                  "/" +
                                                  strToLowerCase(vehicle.slug) +
                                                  "/" +
                                                  strToLowerCase(
                                                    vehicle.slug_id.toString()
                                                  )
                                                }
                                              >
                                                <a className="sitemap-listing-link">
                                                  {vehicle.name}
                                                </a>
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </div>
                                  </Col>
                                ))}

                              <Col md={4} sm={6}>
                                <div className="sitemap-listing-block">
                                  <h3 className="sitema-listing-title">
                                    Serving
                                  </h3>
                                  <ul className="sitemap-listing">
                                    {/* Dynamically Repeat below Element */}
                                    {sitemap1.serving.map((serving, index) => (
                                      <li
                                        className="sitemap-listing-item"
                                        key={index}
                                      >
                                        <Link
                                          href={
                                            "/" +
                                            strToLowerCase(
                                              sitemap1.state_short_name
                                            ) +
                                            "/" +
                                            strToLowerCase(serving.slug)
                                          }
                                        >
                                          <a className="sitemap-listing-link">
                                            {serving.pagename}
                                          </a>
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </Col>
                            </Row>
                          </Tab.Pane>
                        ))}
                      </Tab.Content>
                    </Tab.Container>

                    {/* Other sitemap links block */}
                    <Row>
                      {/* Dynamically Repeat below Element */}
                      <Col md={4} sm={6}>
                        <div className="sitemap-listing-block">
                          <h3 className="sitema-listing-title">blogs</h3>
                          <ul className="sitemap-listing">
                            {sitemapblogs?.length > 0 &&
                              sitemapblogs.map((sitemapBlogs, index) => {
                                return (
                                  <>
                                    <li
                                      className="sitemap-listing-item"
                                      key={index}
                                    >
                                      <Link href={sitemapBlogs.slug}>
                                        <a className="sitemap-listing-link">
                                          {sitemapBlogs.title}
                                        </a>
                                      </Link>
                                    </li>
                                  </>
                                );
                              })}
                          </ul>
                        </div>
                      </Col>

                      <Col md={4} sm={6}>
                        <div className="sitemap-listing-block">
                          <h3 className="sitema-listing-title">company</h3>
                          <ul className="sitemap-listing">
                            {sitemapCms?.length > 0 &&
                              sitemapCms.map((cmsAbout, index) => {
                                return (
                                  <Fragment key={index}>
                                    {cmsAbout.slug === "about" && (
                                      <li key={index}>
                                        <Link href={cmsAbout.slug}>
                                          <a className="sitemap-listing-link">
                                            {cmsAbout.title}
                                          </a>
                                        </Link>
                                      </li>
                                    )}
                                  </Fragment>
                                );
                              })}

                            <li key="2">
                              <Link href="/vehiclebooking">
                                <a className="sitemap-listing-link">
                                  Reserve Now
                                </a>
                              </Link>
                            </li>
                            <li key="3">
                              <Link href="/blog">
                                <a className="sitemap-listing-link">Blog</a>
                              </Link>
                            </li>
                            <li key="4">
                              <Link href="/faqs">
                                <a className="sitemap-listing-link">FAQs</a>
                              </Link>
                            </li>
                            {sitemapCms?.length > 0 &&
                              sitemapCms.map((cms, index) => {
                                return (
                                  <Fragment key={index}>
                                    {cms.slug !== "about-us" && (
                                      <li
                                        className="sitemap-listing-item"
                                        key={index}
                                      >
                                        <Link href={"/" + cms.slug}>
                                          <a className="sitemap-listing-link">
                                            {cms.title}
                                          </a>
                                        </Link>
                                      </li>
                                    )}
                                  </Fragment>
                                );
                              })}
                          </ul>
                        </div>
                      </Col>

                      <Col md={4} sm={6}>
                        <div className="sitemap-listing-block">
                          <h3 className="sitema-listing-title">other</h3>
                          <ul className="sitemap-listing">
                            <li className="sitemap-listing-item">
                              <Link href="/vehiclebooking">
                                <a className="sitemap-listing-link">
                                  Reservations
                                </a>
                              </Link>
                            </li>
                            <li className="sitemap-listing-item">
                              <Link href="/contact-us">
                                <a className="sitemap-listing-link">
                                  Contact Us
                                </a>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Footer
            locations={locations}
            brandList={brandList}
            categoryList={categoryList}
            addressInfo={addressInfo}
            dynamicPageList={dynamicPageList}
            currentLocationId={currentLocationId}
            isShowAddressInfo={isShowAddressInfo}
            selectedLocationName={selectedLocationName}
            cmsList={cmsList}
          />
        </>
      )}
    </>
  );
};
export default SiteMap;

/********************
  @purpose : server side rendering
  @Parameter : {}
  @Author : INIC
  ******************/
export const getServerSideProps = withServerStore(async ({ res, store }) => {
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=0, stale-while-revalidate=59"
  );

  let id = "";
  let list = "";
  let locations = "";
  let brandList = "";
  let categoryList = "";
  let addressInfo = "";
  let metaData = "";
  let sitemap = "";
  let dynamicPageList = "";
  let cmsList = "";

  // get locations list
  list = await store.dispatch(getLocations(true));

  if (list && list.statusCode != "503") {
    locations = list?.data;

    id = locations[0]["id"];

    // get meta data of home page
    metaData = await store.dispatch(getMetaData(id, "home", "pageName"));

    //get siteMap
    sitemap = await store.dispatch(getSitemap());

    // get brand list using location id
    brandList = await store.dispatch(getBrandList(id));

    // get category list using location id
    categoryList = await store.dispatch(getCategoryList(id));

    // get address info using location id
    addressInfo = await store.dispatch(getAddressInfo(id));

    // get dynamic page using location id
    dynamicPageList = await store.dispatch(getDynamicPageList(id));

    cmsList = await store.dispatch(getCmsList());
  } else {
    return {
      redirect: {
        destination: "/maintenance",
      },
    };
  }

  return {
    props: {
      metaData: metaData,
      locations: locations,
      brandList: brandList,
      categoryList: categoryList,
      addressInfo: addressInfo,
      dynamicPageList: dynamicPageList,
      currentLocationId: id,
      isShowAddressInfo: true,
      selectedLocationName: "ca",
      cmsList,
      sitemap,
    },
  };
});
